// extracted by mini-css-extract-plugin
export default {"btn":"po94BvkfZr0UslHODMUX"};